import styles from "./index.module.scss";

export const control = (provided, state) => ({
  ...provided,
  display: "inline-flex",
  minWidth: "240px",
  background: "white",
  padding: "0 10px",
  border: state.isFocused
    ? `1px solid ${styles.grey_400}`
    : `1px solid ${styles.grey_400}`,
  boxShadow: state.isFocused
    ? `0px 0px 0px 3px ${styles.blue_200}`
    : `0px 0px 0px 3px transparent`,
  borderRadius: "4px",
  "&:focus, &:hover": {
    borderColor: styles.grey_300,
  },
});

export const clearIndicator = (provided) => ({
  ...provided,
  color: styles.grey_400,
  ":hover": {
    color: "initial",
  },
});

export const dropdownIndicator = (provided, state) => ({
  ...provided,
  color: "black",
  transition: "transform 100ms ease-in-out",
  transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : "none",
  ":hover": {
    color: "initial",
  },
});

export const indicatorSeparator = () => ({ display: "none" });

export const menu = (provided) => ({
  ...provided,
  width: "250px",
  borderRadius: "4px",
  boxShadow: "0px 1px 3px 0px #3F3F4426, 0px 0px 0px 1px #3F3F440D",
});

export const menuList = (provided) => ({
  ...provided,
  padding: "0",
  border: `1px solid ${styles.grey_300}`
});

export const option = (provided, state) => ({
  ...provided,
  width: "100%",
  padding: "10px",
  background: state.isFocused ? styles.blue_100 : "transparent",
  display: "flex",
});

export const placeholder = (provided) => ({
  ...provided,
  fontSize: "16px",
  color: styles.grey_500,
  display: "flex",
  alignItems: "center",
});

export const valueContainer = (provided) => ({
  ...provided,
  padding: "2px 0",
});
